import dayjs from 'dayjs';

import { getJackpotRecordList } from '@/api/jackpot';
import Table from '@/components/table';

import styles from './styles.module.less';

export default function JackpotRecord() {
  return (
    <>
      {/* <AmountMenu /> */}
      <div className={styles.jackpot_record}>
        <Table
          theme={styles.jackpot_record_table}
          rowKey={'recordid'}
          columns={[
            {
              title: 'Number',
              width: 110,
              dataIndex: 'recordid',
              render: v => <div style={{ wordBreak: 'break-all' }}>{v}</div>
            },
            {
              title: 'Value',
              width: 110,
              dataIndex: 'award',
              render: v => <span className={styles.cash}>$ {v?.toFixed(2)}</span>
            },
            {
              title: 'Time',
              dataIndex: 'rdate',
              width: 110,
              render: v => dayjs(v).format('MM/DD HH:mm')
            }
          ]}
          request={async () => {
            const data = await getJackpotRecordList();
            const record = data.record;
            if (data.ret !== 0 || !record?.length) {
              return {
                total: 0,
                data: []
              };
            }

            return {
              total: 0,
              data: record
            };
          }}
        />
      </div>
    </>
  );
}
